import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Button from '../../../components/common/Button';
import { close as dispatchClose } from '../../../modules/modal/actions';

const mapDispatchToProps = {
  close: dispatchClose
};

const CashInInfo = ({ close }) => (
  <div className="modal modal--zero-padding">
    <div className="cash-in-info modal__content-scrollable">
      <div className="cash-in-info__header">
        <h2 className="modal__header">Cash out suspended</h2>
      </div>
      <h3 className="modal__sub-header">
        Why is my ‘Cash-Out’ value suspended?
      </h3>
      <p className="modal__paragraph">
        The option to ‘Cash-Out’ your bet allows you to choose to settle your bet at the currently
        displayed value, but only if the bet is Live (still running) and odds are still available
        on every unsettled selection. Although we will try to ensure you can Cash-Out your bet at
        all times once it is tracked, there are sometimes reasons why a Cash-Out value cannot be
        offered. Some examples of why this may happen are detailed below, but these are not
        exhaustive and there may be other reasons which are not listed.
      </p>
      <p className="modal__paragraph">
        <b>Odds unavailable</b> - At least one selection within your bet is currently live (in-play
        now)
        but we are not offering live prices on that betting market so we cannot provide an up to
        the second cash-out value.
      </p>
      <p className="modal__paragraph">
        <b>Odds Suspended</b> – If, due to changes in the event or market concerned, (Goal being
        scored,
        Penalty awarded etc.) the cash-out value has changed significantly between the time it was
        displayed on screen and the time our system received confirmation of your cash-out request,
        your Cash-out request will not be completed and you will return to the previous screen.
      </p>
      <p className="modal__paragraph">
        <b>Poor Connectivity</b> – If your mobile device/tablet is not connected to the internet, or
        the
        signal strength is very poor or intermittent, it will not be possible for us to provide a
        valid cash-out value.
      </p>
      <p className="modal__paragraph">
        <b>Technical Issues</b> - There may be occasions where we experience technical issues with
        our
        systems meaning we are not be able to provide a cash-out value. We will always work to
        resolve these issues as quickly as possible.
      </p>
      <h3 className="modal__sub-header">
        Why was my Cash-Out request unsuccessful?
      </h3>
      <p className="modal__paragraph">
        On live events, there can be a delay between a customer’s request to Cash-Out and the
        payout amount being confirmed. When a request is processed, if the actual ‘Cash-Out’ value
        is suspended for any of the reasons above, your request will be unable to be completed.
        You will be returned to your original bet where an updated ‘Cash-Out’ value will be
        displayed shortly.
      </p>
      <p className="modal__paragraph">
        <b>
          Please note, William Hill accepts no liability for any losses incurred in the event a
          request to cash out a bet is unsuccessful
        </b>
      </p>
    </div>
    <div className="cash-in-info__footer">
      <Button className="modal__button button--secondary" onClick={close}>Close</Button>
    </div>
  </div>
);

CashInInfo.propTypes = {
  close: PropTypes.func.isRequired
};

export default connect(null, mapDispatchToProps)(CashInInfo);
